import { Text, View } from "react-native";

export default function StarRating({ rating = 0, reviewCount = 0 }) {
  const fullStars = Math.floor(rating);
  const emptyStars = Math.max(0, 5 - fullStars);

  return (
    <View style={{ flexDirection: "row", alignItems: "center", gap: 6 }}>
      <Text style={{ fontSize: 14 }}>
        {"★".repeat(fullStars)}
        {"☆".repeat(emptyStars)}
      </Text>
      <Text style={{ fontSize: 12, color: "#666" }}>
        {Number(rating).toFixed(1)} ({Number(reviewCount)})
      </Text>
    </View>
  );
}
